
export { useDevice } from "/app/src/contexts/device/index.tsx"
export { useMedia } from "/app/src/contexts/device/index.tsx"